import React from "react";
import { RouteProps } from "react-router-dom";
import PrivateRoute from "../../PrivateRoutes";

interface LicenseGatedRouteProps extends RouteProps {
  component?: React.ComponentType<any>;
  subscriptionId?: string;
  restricted?: boolean;
  section?: string;
}

/**
 * Route wrapper that renders the page component regardless of license status.
 * The LicenseOverlay in PrivateLayout handles the lockout UX
 * (blurred content + overlay + upgrade modal) for unlicensed sections.
 */
const LicenseGatedRoute: React.FC<LicenseGatedRouteProps> = ({
  component: Component,
  section: _section,
  subscriptionId,
  restricted = false,
  render: _render,
  ...rest
}) => {
  return (
    <PrivateRoute
      component={Component}
      subscriptionId={subscriptionId}
      restricted={restricted}
      {...rest}
    />
  );
};

export default LicenseGatedRoute;
